module.exports = __webpack_public_path__ + "img/cultureClose2.0bf8607d.png";